module.exports = __webpack_public_path__ + "static/media/medium-gondola.f5f4ac21.png";